(() => {
  if (window.__oddOneAiPreviewProtectionInstalled) return;
  window.__oddOneAiPreviewProtectionInstalled = true;

  const MARK = 'odd-one-ai-protected-surface';
  const style = document.createElement('style');
  style.id = 'odd-one-ai-preview-protection-style';
  style.textContent = [
    '.' + MARK + ' img {',
    '-webkit-user-drag: none !important;',
    '-webkit-touch-callout: none !important;',
    'user-select: none !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);

  const protect = () => {
    document.querySelectorAll('.odd-one-design-modal__result-image').forEach((surface) => {
      if (surface.querySelector('img[src]')) surface.classList.add(MARK);
    });
    document.querySelectorAll('.odd-one-native-preview[data-visible="true"]').forEach((surface) => {
      surface.classList.add(MARK);
    });
    document.querySelectorAll('.odd-one-live-preview[data-visible="true"] .odd-one-live-preview__art').forEach((surface) => {
      surface.classList.add(MARK);
    });
    document.querySelectorAll('.cart-items__media-container').forEach((surface) => {
      const preview = surface.querySelector('img[data-odd-one-preview-url], img[src*="/api/shopify/cart-preview/"]');
      surface.classList.toggle(MARK, Boolean(preview));
    });
  };

  const isProtected = (target) => target instanceof Element && Boolean(target.closest('.' + MARK));

  document.addEventListener('contextmenu', (event) => {
    if (isProtected(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('dragstart', (event) => {
    if (isProtected(event.target)) event.preventDefault();
  }, true);

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      protect();
    });
  };
  const observer = new MutationObserver((records) => {
    if (records.some((record) =>
      record.type === 'attributes' || Array.from(record.addedNodes).some((node) =>
        node instanceof Element && (
          node.matches('.odd-one-design-modal__result-image,.odd-one-native-preview,.odd-one-live-preview,.cart-items__media-container')
          || Boolean(node.querySelector('.odd-one-design-modal__result-image,.odd-one-native-preview,.odd-one-live-preview,.cart-items__media-container'))
        )
      )
    )) schedule();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'data-visible', 'data-odd-one-preview-url'],
  });
  schedule();
})();